import { useQuery } from '@tanstack/react-query';
import { UserPlus } from 'lucide-react';
import type { WaitingListEntry } from '@hch/shared';
import { Badge } from '~/components/ui/primitives';
import { DataTable, type Column } from '~/components/shared/data-table';
import { PageHeader } from '~/components/shared/states';
import { api } from '~/lib/api';
import { queryKeys } from '~/lib/queries';
import { formatDate } from '~/lib/utils';

/** RG-05 : prospects dont l'adresse n'est pas encore desservie. */

const COLONNES: Array<Column<WaitingListEntry>> = [
  {
    header: 'Contact',
    cell: (entree) => (
      <>
        <span className="font-medium">
          {entree.firstName} {entree.lastName}
        </span>
        <br />
        <span className="text-xs text-muted-foreground">{entree.email}</span>
      </>
    ),
  },
  {
    header: 'Adresse',
    cell: (entree) => (
      <>
        {entree.street}
        <br />
        <span className="text-muted-foreground">
          {entree.postalCode} {entree.city}
        </span>
      </>
    ),
    className: 'text-sm',
  },
  {
    header: 'Message',
    cell: (entree) => entree.message ?? '—',
    className: 'max-w-64 text-sm text-muted-foreground',
  },
  {
    header: 'Recu le',
    cell: (entree) => formatDate(entree.createdAt),
    nowrap: true,
    className: 'text-xs',
  },
  {
    header: 'Statut',
    cell: (entree) => (
      <Badge variant={entree.status === 'PENDING' ? 'warning' : 'secondary'}>
        {entree.status === 'PENDING' ? 'A traiter' : entree.status}
      </Badge>
    ),
  },
];

export function AdminWaitingListPage() {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: queryKeys.waitingList,
    queryFn: () => api.get<WaitingListEntry[]>('/waiting-list'),
  });

  return (
    <div className="app-page">
      <PageHeader
        title="Liste d'attente"
        description="Prospects dont l'adresse se situe hors des zones actuellement desservies."
      />

      <DataTable
        columns={COLONNES}
        rows={data}
        rowKey={(entree) => entree.id}
        isLoading={isLoading}
        error={error}
        onRetry={() => void refetch()}
        emptyIcon={UserPlus}
        emptyTitle="Aucun prospect en attente"
      />
    </div>
  );
}
